import { Component, Inject, NgZone, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectionService } from '../../connection.service';
import { ClientPlatformService } from '../../../../client-platform/client-platform.service'
import { SmsService } from 'src/app/shared/services/sms-service.service';
import { QoutaPopupComponent } from 'src/app/shared/qouta-popup/qouta-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { isPlatformBrowser } from '@angular/common';
import { UIConfigService } from 'src/app/shared/services/UIConfigService';

@Component({
    selector: 'connection-app-listing',
    templateUrl: './connection-app-listing.component.html',
    styleUrls: ['./connection-app-listing.component.css'],
    standalone: false
})
export class ConnectionAppListingComponent implements OnInit {
  isBrowser: boolean;

  //get methods
  get connectionService() { return this._connectionService }
  get router() { return this._router }
  get route() { return this._route }
  get clientPlatformService() { return this._clientPlatformService; }
  urlParams: any = {};

  appConfig: any;
  //Constructor
  constructor(
    private _connectionService: ConnectionService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _clientPlatformService: ClientPlatformService,
    private smsService: SmsService,
    private dialog: MatDialog,
    public authService: AuthServiceService,
    public snackBar: MatSnackBar,
    private ngZone: NgZone,
    public uic: UIConfigService,
    @Inject(PLATFORM_ID) platformId: Object,

  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    //Check New Connection is clicked or Leftnav Connection is clicked
    this.route.queryParamMap.subscribe((params:any) => {
      console.log('params', params)
      this.urlParams = params;

      // Process the client platform parameters to determine if menu items should be hidden
      // and to store client-specific information such as clientType and sourceApp
      this.clientPlatformService.processClientPlatformParams(params);

      if (params.get('workspaceid')) {
        this.connectionService.workSpaceId = params.get('workspaceid');
      }

      this.workSpaceId = this.connectionService.workSpaceId;
      console.log("this.workspaceId", this.connectionService.workSpaceId )

      if (decodeURIComponent(params.get('authorization')) != 'null') {
        this.connectionService.preAuthenticatedToken = decodeURIComponent(
          params.get('authorization')
        );
      }

      this.preAuthenticatedToken = this.connectionService.preAuthenticatedToken;

      this.isZeroConnection = JSON.parse(params.get('iszeroconnection')) || false;

      if (params.get('filter')) {
        console.log("filter", params.get('filter'))
        this.appConfig = {};
        this.appConfig.filter = params.get('filter');
      }

    });

  }
  //Local Variable
  workSpaceId: any;
  preAuthenticatedToken: any;
  //flags
  isZeroConnection: boolean = false;

  //ngOnInit
  ngOnInit() {
    if(this.connectionService.workSpaceId) return;
    if(!this.isBrowser) return;
    this.authService.authCheckPositive.subscribe(async (authStatus) => {
      //if logged in
      if (authStatus) {
        console.log('logged in');
        await this.connectionService.getWorkSpaceId();
      } else {
        // this.snackBar.open('Your session has expired. Please log in again to continue.', 'ok', {
        //   horizontalPosition: 'center',
        //   verticalPosition: 'top',
        // });
        // redirect to login page
        this.ngZone.run(() => {
          this.router.navigate(['../']);
        });
        return;
      }
    });
  }

  initialize(){

  }
  //User Clicked on app from select an app for new connection => shows new connection
  addNewRecord(box: any) {

    let eligibility = this.smsService.checkEligibility("CONNECTION");
    console.log("isEligible", eligibility);
    if(!eligibility.isEligible){
      this.dialog.open(QoutaPopupComponent, {
            minWidth: "260px",
            height: "auto",
            data: {
              type: "CONNECTION"
            },
          });
      return ;
    }

    console.log("this.urlParamas:", this.urlParams.params);

    this.router.navigate(['connection/newconnection'], {
      state: { box: box },
      queryParams: {
        workspaceid: this.workSpaceId,
        authorization: encodeURIComponent(this.preAuthenticatedToken),
        isEdit: false,
        redirectUrl: this.urlParams && this.urlParams.params &&  this.urlParams.params.redirectUrl ? this.urlParams.params.redirectUrl : undefined
      },
    });
  }
}
